// extracted by mini-css-extract-plugin
export default {"container":"assessmentInfoCard_container__HNNF7","text":"assessmentInfoCard_text__dSDrq"};